import { Link } from "react-router-dom";
import { ConnectKitButton } from "connectkit";
import { PenLine } from "lucide-react";
import { useAuth } from "@/context/useAuth";

export function Navigation() {
  const { isAuthenticated } = useAuth();

  return (
    <header className="border-b border-beige/20 bg-white/80 backdrop-blur-sm sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-xl font-display font-bold">x402stack</span>
        </Link>

        <div className="flex items-center gap-3">
          {isAuthenticated ? (
            <Link
              to="/writer/dashboard"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-body font-bold text-black hover:text-orange transition-colors"
            >
              <PenLine size={16} />
              Dashboard
            </Link>
          ) : (
            <Link
              to="/login"
              className="text-sm font-body font-bold text-grey hover:text-black transition-colors"
            >
              Write
            </Link>
          )}
          <ConnectKitButton.Custom>
            {({ isConnected, show, truncatedAddress, ensName }) => (
              <button
                onClick={show}
                className="px-3 py-1.5 rounded-lg text-sm font-body font-bold border border-beige/40 hover:border-beige transition-colors"
              >
                {isConnected
                  ? ensName || truncatedAddress
                  : "Connect Wallet"}
              </button>
            )}
          </ConnectKitButton.Custom>
        </div>
      </div>
    </header>
  );
}
